import { useEffect, useLayoutEffect } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { connect } from 'react-redux';
import { sessionCheckRequest, sessionCheckReset } from '../../store/action/sessionAction';
import { loginReset } from '../../store/action/loginAction';
import './ProtectedRoute.css';

const SESSION_CHECK_INTERVAL_MS = 60 * 60 * 1000; // 1 hour

const ProtectedRoute = ({ isSessionValid, checkSession, resetLogin, resetSession }) => {
  useLayoutEffect(() => {
    resetSession();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    checkSession();
    const intervalId = setInterval(checkSession, SESSION_CHECK_INTERVAL_MS);
    return () => clearInterval(intervalId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (isSessionValid === false) {
      resetLogin();
      resetSession();
    }
  }, [isSessionValid, resetLogin, resetSession]);

  if (isSessionValid === null) {
    return <div className="sessionLoader"/>;
  }

  return isSessionValid ? <Outlet/> : <Navigate to="/login" />;
}

const mapStateToProps=(state) => ({
  isSessionValid: state.sessionReducer.isSessionValid,
})

const mapDispatchToProps = (dispatch) => ({
  checkSession: () => dispatch(sessionCheckRequest()),
  resetLogin: () => dispatch(loginReset()),
  resetSession: () => dispatch(sessionCheckReset()),
});

export default connect(mapStateToProps,mapDispatchToProps)(ProtectedRoute)
